<div [class]="computedContainerClasses()">
  <!-- Glass shimmer effect -->
  <div
    class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden rounded-lg">
    <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/10 to-transparent
                    transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                    transition-transform duration-1500 ease-out"></div>
  </div>

  <!-- Premium floating particles -->
  @if (variant === 'premium') {
  <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-20 rounded-lg">
    <div class="absolute top-1/4 left-1/6 w-1.5 h-1.5 bg-primary-400/40 rounded-full animate-pulse"></div>
    <div class="absolute bottom-1/3 right-1/4 w-1 h-1 bg-white/30 rounded-full animate-pulse delay-1000"></div>
    <div class="absolute top-3/4 left-3/4 w-0.5 h-0.5 bg-primary-300/50 rounded-full animate-pulse delay-2000"></div>
  </div>
  }

  <!-- Tab List -->
  <div [class]="computedTabListClasses()" role="tablist" [attr.aria-orientation]="orientation">
    @for (tab of tabs; track tab.value; let i = $index) {
    <button [class]="getTabButtonClasses(tab.value || '')" [disabled]="tab.disabled"
      [attr.aria-selected]="isActiveTab(tab.value || '')" [attr.aria-controls]="'tab-panel-' + (tab.value || '')"
      [attr.aria-label]="tab.label" [id]="'tab-' + (tab.value || '')" role="tab" (click)="selectTab(tab.value || '')"
      (keydown)="handleTabKeyDown($event, i)">
      <!-- Tab Icon -->
      @if (tab.icon) {
      <ui-icon [name]="tab.icon" [size]="iconSize()" customClass="mr-2 transition-colors duration-300"></ui-icon>
      }

      <!-- Tab Label -->
      <span class="tab-label truncate">{{ tab.label }}</span>

      <!-- Tab Badge -->
      @if (tab.badge) {
      <span class="ml-2 px-2 py-0.5 text-xs bg-red-500/80 text-white rounded-full backdrop-blur-sm">
        {{ tab.badge }}
      </span>
      }

      <!-- Tab glass shimmer effect -->
      <div
        class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-lg">
        <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/20 to-transparent
                          transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                          transition-transform duration-1000 ease-out"></div>
      </div>

      <!-- Premium floating particles on tab -->
      @if (variant === 'premium' && isActiveTab(tab.value || '')) {
      <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-30 rounded-lg">
        <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-primary-400/60 rounded-full animate-pulse"></div>
        <div class="absolute bottom-1/4 right-1/4 w-0.5 h-0.5 bg-white/60 rounded-full animate-pulse delay-500"></div>
      </div>
      }
    </button>
    }

    <!-- Active Tab Indicator -->
    @if (variant !== 'pills') {
    <div [class]="computedIndicatorClasses()" [style]="indicatorStyle()"></div>
    }
  </div>

  <!-- Tab Content -->
  <div [class]="computedContentClasses()">
    @for (tab of tabs; track tab.value) { @if (isActiveTab(tab.value || '')) {
    <div [id]="'tab-panel-' + (tab.value || '')" [attr.aria-labelledby]="'tab-' + (tab.value || '')" role="tabpanel"
      class="animate-glass-fade-in" [attr.data-tab-panel]="tab.value || ''">
      @if (tab.template) {
      <ng-container [ngTemplateOutlet]="tab.template"></ng-container>
      }
    </div>
    } }

    <!-- Custom content projection - use data-tab="tab-value" on your elements -->
    <!-- Note: Due to Angular limitations, content projection in loops is not supported. Use tab.template instead. -->
    <div class="tabs-custom-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>